// vue
import Vue from 'vue';
import App from './App.vue';
// 路由 vue router
import router from './router';
// 全局
import global from '@/assets/js/global.js';
// 輪播 swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
// 鼠标经过图片局部放大 vue-piczoom
// import PicZoom from 'vue-piczoom';
// 請求 axios
import axios from 'axios';
// SEO
import MetaInfo from 'vue-meta-info';
// 多语言
import i18n from './tools/i18n';
// 引入vue-amap
import VueAMap from 'vue-amap';


// websocket
// import VueSocketIO from 'vue-socket.io';
// import SocketIO from "socket.io-client";
// UI框架 element-ui
import { MessageBox, Popover, Select, Option, Dialog, Form, FormItem, Input, Button, Upload, Image } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/element-ui/index.css';
import '@/assets/css/element-ui/fonts/element-icons.ttf';
import '@/assets/css/element-ui/fonts/element-icons.woff';
// 項目 css
import '@/assets/css/App.css';
import '@/assets/css/components/Header.css';
import '@/assets/css/components/Header.css';
import '@/assets/css/components/Footer.css';
import '@/assets/css/components/ShortcutOperation.css';
import '@/assets/css/Login.css';
import '@/assets/css/Home.css';
import '@/assets/css/Biaodi.css';
import '@/assets/css/BiaodiDetails.css';
import '@/assets/css/GonggaoDetails.css';
import '@/assets/css/Person.css';
import '@/assets/css/Paimaigonggao.css';
import '@/assets/css/Paimaiqiye.css';
import '@/assets/css/Problem.css';
import '@/assets/css/Progess.css';
import '@/assets/css/QiyeDetails.css';
import '@/assets/css/Serivce.css';
// import '@/assets/css/Aboutwe.css';
import '@/assets/css/Meetings.css';
import '@/assets/css/Partner.css';
import '@/assets/css/about/Synopsis.css';
import '@/assets/css/about/Service.css';
import '@/assets/css/about/Honor.css';
import '@/assets/css/about/Development.css';
import '@/assets/css/about/Contact.css';
import '@/assets/css/about/Culture.css';

// amap 一直错误显示（key现在是否失效不确定）
window.addEventListener('error', function (e) {
	if (e.message && e.message.includes('AMap is not defined')) {
		e.stopPropagation()
		e.preventDefault()
		return false
	}
})


Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);
Vue.use(MetaInfo);
// Vue.use(PicZoom);
Vue.prototype.axios = axios;
Vue.prototype.$global = global;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.use(Popover);
Vue.use(Select);
Vue.use(Option);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Button);
Vue.use(Upload);
Vue.use(Image);
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 };
Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
	key: '7f24d70f9de2b4e9e50bee4231a252d5',
	v: '1.4.15',           // 使用较新版本
	plugin: ['AMap.Geocoder']  // 如果需要其他插件可以继续加
});

// Vue.use(new VueSocketIO({
// 	debug: true,
// 	connection: SocketIO('http://api.paijie.com:2021')
// }));

router.afterEach((to, from, next) => {
	setTimeout(() => {
		// 百度统计
		var _hmt = _hmt || [];
		(function () {
			//每次执行前，先移除上次插入的代码
			document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			var hm = document.createElement("script");
			hm.src = "https://hm.baidu.com/hm.js?220551d4641f3337c80e69fda4553598";
			hm.id = "baidu_tj"
			var s = document.getElementsByTagName("script")[0];
			s.parentNode.insertBefore(hm, s);
		})();

		// 百度链接提交
		(function () {
			document.getElementById('baidu_tj_auto') && document.getElementById('baidu_tj_auto').remove();
			var bp = document.createElement('script');
			var curProtocol = window.location.protocol.split(':')[0];
			if (curProtocol === 'https') {
				bp.src = 'https://zz.bdstatic.com/linksubmit/push.js';
				bp.id = "baidu_tj_auto";
			}
			else {
				bp.src = 'http://push.zhanzhang.baidu.com/push.js';
				bp.id = "baidu_tj_auto";
			}
			var s = document.getElementsByTagName("script")[0];
			s.parentNode.insertBefore(bp, s);
		})();
	}, 0);
});

new Vue({
	i18n,
	router,
	render: h => h(App)
}).$mount('#app')

